import { createFileRoute } from "@tanstack/react-router";

import { ActionItemsPage } from "../../pages/dashboard/action-items/ActionItems.page";
import { parseActionItemsSearch } from "../../pages/dashboard/action-items/search";

/**
 * The worklist's landing route.
 *
 * `parseActionItemsSearch` defaults `scope` to `mine`, so arriving here with a
 * bare `/action-items` shows the signed-in user's own items on first load and
 * on every nav-in, while everything the user then changes — including widening
 * to `scope=all` — is read back out of the URL.
 */
export const Route = createFileRoute("/_protected/action-items/")({
  validateSearch: parseActionItemsSearch,
  component: ActionItemsIndexRoute,
});

function ActionItemsIndexRoute() {
  const navigate = Route.useNavigate();

  return (
    <ActionItemsPage
      search={Route.useSearch()}
      // `replace`: filtering is not a navigation step, so the back button
      // leaves the page instead of walking back through every keystroke.
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
